import AuthService from '@/services/auth.service';

import TokenService from '@/services/token.service';
import VueCookies from 'vue-cookies';

import {defineStore} from "pinia";
 //import {useLocalStorage} from "@vueuse/core";
import api from "@/services/api";
import {useLocalStorage} from "@vueuse/core";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        status: useLocalStorage('status', {loggedIn: false}),
        //user:{},
        //permission:[]
         user: TokenService.getUser(),
         permission: TokenService.getPem(),
    }),
    hydrate(state) {
       state.user = useLocalStorage('user', 'null')
    },
    getters:{
        //we use this function to check whenever user had loggedIn or Not
        isLoggedIn() {
            
            return this.user && this.status.loggedIn;
        },
        getUserData(state) {
            return state.user;
        },
        getUser(state){
            return state.user;
        },
        getUserInfo(state){
            return (state.user);
        },
        getPem(state){
            return state.permission;
        },
    },
    actions: {
        async allowPolicy(){
            await api.put("auth/allow-policy").then(()=>{
                
                let user = TokenService.getUser();
                user.allow_policy = 1;
                TokenService.setUser(user)          
                
            });
        },
        async checkResetPassword(data){
           
            return Promise.resolve(await AuthService.checkResetPassword(data));
         },
        async resetPassword(data){
           
            return Promise.resolve(await AuthService.resetPassword(data));
         },
        setUser(objUser){
            TokenService.setUser(objUser)          
            this.loginSuccess(objUser);
        },
        async login(credentials) {
            
            return api.post("auth/login", credentials).then(
                (response) => {
                    let success = response.data.success;
                    if(success){
                        VueCookies.config('1d','','',true)
                        VueCookies.set('refresh_token' , response.data.refresh_token,"7d") 
                        VueCookies.set('access_token',response.data.access_token,"1d")
                        let ojbUser =  (response.data.user);
                        this.setUser(ojbUser);
                        
                        return Promise.resolve(response);
                    }else{
                        return Promise.reject(response);
                    }
                },
                (error) => {
                    return Promise.reject(error);
                }
            )
        },
        async savePassword(data) {
            return await AuthService.doResetPassword(data);
            
        },

        async checkLogin()  {
            var x = await AuthService.checkLogin();
            if(x.status!==200){
                this.loginFailure();
            }
        },
        updatePhoto(data){
            return AuthService.upload(data).then(
                response => {
                    if(response.data.status==true){
                        this.changeUserInfo({data:response.data.data.url,type:response.data.data.type});
                    }
                    return Promise.resolve(response);
                },
                error => {
                    //  commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout() {
            AuthService.logout().then(() => {
                this.loginFailure();
                VueCookies.set("access_token", null);
                VueCookies.set("refresh_token", null);
            });
        },
        register(user) {
            return AuthService.register(user).then(
                response => {
                    this.registerSuccess();
                    return Promise.resolve(response.data);
                },
                error => {
                    this.registerFailure();
                    return Promise.reject(error);
                }
            );
        },

        updateInfo(data){
            return AuthService.updateInfo(data).then((x) => {

                if(x.data.status==true){
                    this.changeUserInfo(x.data.data);
                }
                return Promise.resolve(x);
            })
                .catch(error => {
                    throw error
                });
        },
        setPem(pem){
          
            this.set_permission(pem);
        },
        changeUserInfo(user){
            if(user.type!=undefined){
                TokenService.setUserInfo(user.data,user.type);
            }else{
                TokenService.setUserInfo(user);
            }
            user = TokenService.getUser();
            this.user = user;
        },
        loginSuccess( user) {
            this.status.loggedIn = true;
            this.user = user;
        },
        loginFailure() {
            this.status.loggedIn = false;
            this.user = null;
        },

        registerSuccess() {
            this.status.loggedIn = false;
        },
        registerFailure() {
            this.status.loggedIn = false;
        },

        set_permission( permission) {
            this.permission = permission;
        }
    }
});